export class RecertifyModel {
    recertifyId?: any;
    recertificationDeadlineDate?: any;
    isRecertify?: any;
}